<div [ngClass]="{ 'modal-body': !inline }">
  <shared-tables-ngx-datatable
    [config]="config$ | async"
    [data]="data$ | async"
    (onChangeLimit)="onChangeLimit($event)"
    (onChangePage)="onChangePage($event)">
  </shared-tables-ngx-datatable>
</div>

@if (!inline) {
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">
      {{ 'btn.close' | translate }}
    </button>
  </div>
}

<ng-template #createdAt let-row="row">
  <span>{{ row.createdAt | date: FORMAT_FOR_DATES_LONG }}</span>
</ng-template>

<ng-template #action let-row="row">
  <span
    class="badge"
    [ngClass]="row.action === 'blocked' ? 'badge-light-danger' : 'badge-light-success'">
    {{
      (row.action === 'blocked'
        ? 'userManagement.block.historyActionBlocked'
        : 'userManagement.block.historyActionUnblocked'
      ) | translate
    }}
  </span>
</ng-template>
